/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

function RadioButtonSkeleton(props) {
  const {
    className,
    ...rest
  } = props;
  const prefix = usePrefix();
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx(`${prefix}--radio-button-wrapper`, className)
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--radio-button ${prefix}--skeleton`
  }), /*#__PURE__*/React__default.createElement("span", {
    className: `${prefix}--radio-button__label ${prefix}--skeleton`
  }));
}
RadioButtonSkeleton.propTypes = {
  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string
};

export { RadioButtonSkeleton, RadioButtonSkeleton as default };
